import { variants, LabelledLinkTheme } from '../LabelledLinkStyles.css';
import { multiVariantStyles } from './LabelledLinkVariants.css';

const LabelledLinkRedwoodTheme: LabelledLinkTheme = {
  baseTheme: '',
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { LabelledLinkRedwoodTheme };
